import { schema } from '@mesa/core/zero';
import { Row } from '@rocicorp/zero';
import { DoorOpenIcon } from 'lucide-react';
import { useCallback } from 'react';

import { SplitButton, SplitButtonPrimary } from '@/components/ui/split-button';
import { useZero } from '@/lib/zero';


type PullRecordRow = Row<typeof schema.tables.PullsTable>;

interface ReopenButtonProps {
  pull: PullRecordRow;
}

export function ReopenButton({ pull }: ReopenButtonProps) {
  const z = useZero();

  const reopenPull = useCallback(() => {
    if (!pull) return;
    z.mutate.PullsTable.openOrClose({
      nodeId: pull.nodeId,
      owner: pull.owner,
      repo: pull.repo,
      number: pull.number,
      event: 'OPEN',
    });
  }, [z, pull]);

  return (
    <SplitButton variant="outline">
      <SplitButtonPrimary onClick={reopenPull}>
        <DoorOpenIcon className="size-4" />
        Reopen
      </SplitButtonPrimary>
    </SplitButton>
  );
}
